import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'
import { Banner } from '@onboarding'
import styles from '../EnterpriseDashboard/EnterpriseDashboard.module.scss'

export interface PromoItem {
  /** Stable identity, also emitted as the row's `data-test` hook. */
  id: string
  /** Announcement card tint: `brand` (blue) or `action` (yellow). */
  tone: 'brand' | 'action'
  icon: ReactNode
  title: string
  text: string
  ctaLabel: string
  ctaTestId: string
  dismissTestId: string
  onCta: () => void
  onDismiss: () => void
}

interface Props {
  promos: PromoItem[]
}

/**
 * Every eligible dashboard promo as its own announcement card, laid out in one row beneath the
 * Overview. Each card dismisses independently; the group disappears with the last one.
 */
function PromoBanner({ promos }: Props) {
  if (!promos.length) return null

  return (
    <div
      className={cn(styles['enterprise-dashboard__announcements'], 'enterprise-dashboard__announcements')}
      data-test='dashboard-promo-banner'
    >
      {promos.map((promo) => (
        <Banner
          key={promo.id}
          tone={promo.tone}
          icon={promo.icon}
          title={promo.title}
          content={promo.text}
          handleClick={promo.onCta}
          onDismiss={promo.onDismiss}
          dataTest={promo.id}
          actionLabel={promo.ctaLabel}
          actionTestId={promo.ctaTestId}
          dismissTestId={promo.dismissTestId}
        />
      ))}
    </div>
  )
}

export default PromoBanner
